export default __webpack_public_path__ + "static/media/staff_icon.04991af0.svg";